import React from 'react';
import LegalPage from '../components/LegalPage';

const sections = [
    {
        title: 'Cine suntem',
        table: {
            rows: [
                ['Denumirea', 'SC EVOO MEDICAL SRL'],
                ['Cod unic de înregistrare', '39926229 (cod de TVA RO39926229)'],
                ['Registrul comerțului', 'J01/861/2018'],
                ['Sediul social și punctul de lucru', 'mun. Sebeș, loc. componentă Petrești, str. 1 Mai nr. 294, jud. Alba, cod poștal 515850'],
                ['Telefon', '+40 752 875 121'],
                ['E-mail', 'contact@evoomedical.ro'],
                ['Activitatea', 'Centru medical ambulatoriu de specialitate (CAEN 8622 — activități de asistență medicală specializată)'],
                ['Autorizația sanitară de funcționare', 'nr. ______ din ______, emisă de Direcția de Sănătate Publică Alba — se completează la emitere'],
                ['Avizul Colegiului Medicilor Alba și înregistrarea în Registrul unic al cabinetelor medicale', 'se completează la emitere'],
                ['Contract cu Casa de Asigurări de Sănătate', 'Nu. Serviciile se plătesc integral de pacient.']
            ]
        }
    },
    {
        title: 'Autoritățile la care vă puteți adresa',
        items: [
            'Direcția de Sănătate Publică a Județului Alba — pentru condițiile de funcționare a unității medicale.',
            'Colegiul Medicilor Alba — pentru actul medical și conduita medicilor.',
            'Autoritatea Națională pentru Protecția Consumatorilor (ANPC) — pentru drepturile de consumator.',
            'Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP) — pentru datele personale.'
        ]
    },
    {
        title: 'Temeiul',
        unnumbered: true,
        text: 'Legea nr. 365/2002 privind comerțul electronic, art. 5.'
    }
];

function DateIdentificare() {
    return (
        <LegalPage
            eyebrow="Informații legale"
            title="Date de identificare"
            intro="Informațiile de mai jos sunt cele pe care legea comerțului electronic le cere oricărui furnizor care își prezintă serviciile online."
            sections={sections}
            footnote="EVOO-COM-MAN-01-R3 · versiunea din 25.10.2026"
        />
    );
}

export default DateIdentificare;
